import React from "react";
import { mergeStrings } from "../../lib/helpers";
import styled from "styled-components";
import useTheme from "../../lib/useTheme";
import Button from "../Button";
import { COLORS } from "../../lib/constants";

interface DGA_SecondNavHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "style"> {
  style?: "gray" | "primary";
  items: {
    text: React.ReactNode;
    icon: React.ReactNode;
  }[];
  actions: React.ReactElement<typeof Button>[];
}

const SecondNavHeader: React.FC<DGA_SecondNavHeaderProps> = ({
  items,
  actions,
  style = "gray",
  ...props
}) => {
  const theme = useTheme();

  return (
    <StyledComponent
      $theme={theme}
      $style={style}
      className={mergeStrings("dgaui dgaui_secondNavHeader " + (style ?? " "), props.className)}
      {...props}
    >
      <div className="dgaui_secondNavHeaderItems">
        {items.map((item, i) => (
          <div key={i} className="dgaui_secondNavHeaderItem">
            <div className="icon">{item.icon}</div>
            <div className="text">{item.text}</div>
          </div>
        ))}
      </div>

      <div className="dgaui_secondNavHeaderActions">
        {actions.map((action, i) => (
          <div key={i} className="action">
            {action}
          </div>
        ))}
      </div>
    </StyledComponent>
  );
};

const StyledComponent = styled.div<{
  $theme: Theme;
  $style: "gray" | "primary";
}>`
  direction: ${(p) => p.$theme.direction};
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(p) => (p.$style === "gray" ? p.$theme.palette.neutral[300] : COLORS.white30)};

  background-color: ${(p) => p.$theme.palette.primary[600]};
  &.gray {
    background-color: ${(p) => p.$theme.palette.neutral[100]};
  }

  .dgaui_secondNavHeaderItems {
    display: flex;
    align-items: center;

    .dgaui_secondNavHeaderItem {
      color: ${(p) => (p.$style === "gray" ? p.$theme.palette.neutral[700] : COLORS.white)};

      margin-inline-end: 16px;
      display: flex;
      align-items: center;

      .icon {
        margin-inline-end: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .text {
        font-size: 16px;
        white-space: nowrap;
      }
    }
  }

  .dgaui_secondNavHeaderActions {
    display: flex;
    align-items: center;

    .action {
      margin-inline-start: 4px;
      .dgaui_button {
        padding: 4px;
      }
    }
  }
`;

export default SecondNavHeader;
